import React, { useEffect, useRef, useState } from "react";
import { ToastTypes } from "../contexts/toastr.context";
import { UserService } from "../_service/user.service";
import { Button } from "./button.component";

import BulkUserSample from "./../_assets/sample_files/bulk_import_sample.csv";
import { TextInput } from "./text-input.component";
import Table from "./table.component";
import { ActionModal } from "./action-modal.component";
import Switch from "./switch.component";
import { Loader } from "./loader.component";
import { OrganizationService } from "../_service/organization.service";

let userListGlobal = [];

const UserManagement = ({
  user,
  addToast,
  openTab,
  showAddUser,
  setShowAddUser,
  showUserEdit,
  setShowUserEdit,
}) => {
  const roles = [
    { value: "user", label: "User" },
    { value: "orgAdmin", label: "Organization Admin" },
  ];
  const addUserRoles = [{ value: "orgAdmin", label: "Organization Admin" }];
  const hospitalRoles = [{ value: "user", label: "User" }];
  const sp = new URLSearchParams(window.location.search);
  let orgId = sp.get("orgId");

  const [userList, setUserList] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [userData, setUserData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  //   const [showUserEdit, setShowUserEdit] = useState(false);

  const hiddenBulkFileInput = useRef(null);

  const [email, setEmail] = useState("");
  const [role, setRole] = useState(roles[0].value);
  const [isUserActive, setIsUserActive] = useState(true);

  const [orgList, setOrgList] = useState([]);
  const [userOrgId, setUserOrgId] = useState();

  const [name, setName] = useState("");
  const isUserFormSubmitable =
    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email) &&
    name.length >= 1;

  const columns = React.useMemo(
    () => [
      {
        Header: "Name",
        accessor: "name",
        Cell: (data) => {
          return <p className="overflow-auto">{data.row?.values?.name}</p>;
        },
      },
      {
        Header: "Email",
        accessor: "email",
      },
      {
        Header: "Role",
        accessor: "roles",
        Cell: (data) => {
          let role = "";
          if (data.row?.values.roles[0] === "orgAdmin") {
            role = "Admin";
          } else {
            role = "User";
          }
          return <div>{role}</div>;
        },
      },
      {
        Header: "Status",
        accessor: "isActive",
        Cell: (data) => {
          let status = "";
          if (data.row?.values.isActive) {
            status = "Active";
          } else {
            status = "Inactive";
          }
          return (
            <div
              className={
                data.row?.values.isActive ? "text-green-500" : "text-red-500"
              }>
              {status}
            </div>
          );
        },
      },
      {
        Header: "Action",
        accessor: "_id",
        Cell: (data) => {
          return (
            <div>
              {
                <button onClick={() => handleEdit(data.row.original)}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6 text-primary"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}>
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                    />
                  </svg>
                </button>
              }
              <button
                className="ml-4"
                onClick={() => handleDelete(data.row.values)}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6 text-primary"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}>
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                  />
                </svg>
              </button>
            </div>
          );
        },
      },
    ],
    [isUserActive]
  );

  useEffect(() => {
    getOrganizationUsers(orgId);
  }, [openTab === 2]);

  useEffect(() => {
    getOrganizations(user);
    if (showUserEdit && userData && orgList) {
      setName(userData.name ? userData.name : "");
      setEmail(userData.email ? userData.email : "");
      setRole(userData.roles[0] ? userData.roles[0] : "");
      setIsUserActive(userData.isActive);
      setUserOrgId(userData.organizationId);
    }
  }, [showUserEdit, userData]);

  const handleBulkChange = (event) => {
    const bulkUserFile = event.target.files[0];
    const formData = new FormData();
    formData.append("file", bulkUserFile, bulkUserFile.name);
    UserService.addBulkUsers(user, formData, orgId)
      .then((resp) => {
        let newUserList = [...userList, ...resp];
        setUserList(newUserList);
        addToast("Users added successfully", "", ToastTypes.success);
      })
      .catch((error) => {
        if (error && error.response && error.response.data.message) {
          addToast(error.response.data.message, "", ToastTypes.danger);
        }
      });
  };

  const handleBulkFileClick = () => {
    hiddenBulkFileInput.current.click();
  };

  const showAddUserContent = () => {
    setShowUserEdit(false);
    setRole(roles[1].value);
    setShowAddUser(!showAddUser);
    clearUserData();
  };

  const handleDelete = (data) => {
    setIsDeleteModalVisible(true);
    setUserData(data);
  };

  const handleEdit = (data) => {
    setShowAddUser(true);
    setShowUserEdit(true);
    setUserData(data);
    // addToast("Coming Soon", "", ToastTypes.info);
  };

  const filter = (value) => {
    const keyword = value;
    if (keyword !== "") {
      const results = userListGlobal.filter((user) => {
        return user.displayName.toLowerCase().includes(keyword.toLowerCase());
      });
      setUserList(results);
    } else {
      setUserList(userListGlobal);
    }
    setSearchValue(keyword);
  };

  const onSubmitDelete = () => {
    UserService.deleteUser(user, userData._id)
      .then((resp) => {
        addToast("User deleted successfully", "", ToastTypes.success);
        const userFilterData = userList.filter(
          (usr) => usr._id != userData._id
        );
        setIsDeleteModalVisible(false);
        setUserData({});
        userListGlobal = userFilterData;
        setUserList(userFilterData);
        // setUserListGlobal(userFilterData);
      })
      .catch((error) => {
        if (error && error.response && error.response.data.message) {
          addToast(error.response.data.message, "", ToastTypes.danger);
        }
      });
  };

  const addUser = () => {
    const uData = {
      name,
      roles: role,
      isActive: isUserActive,
      email: email.toLowerCase(),
      organizationId: orgId,
    };
    if (showUserEdit && userData) {
      uData.organizationId = userOrgId;
      UserService.updateUser(user, userData._id, uData)
        .then(async (resp) => {
          let newUserList = userListGlobal;
          let index = await newUserList.findIndex(
            (usr) => usr._id === userData._id
          );
          if (index !== -1) {
            newUserList[index] = resp;
            let updatedUserList = newUserList.filter(
              (item) => item.organizationId === orgId
            );
            setUserList(updatedUserList);
            userListGlobal = updatedUserList;
            setEmail("");
            setName(userData.name ? userData.name : "");
            setShowUserEdit(false);
            setShowAddUser(false);
            addToast("User edited successfully", "", ToastTypes.success);
          }
        })
        .catch((error) => {
          if (error && error.response && error.response.data.message) {
            addToast(error.response.data.message, "", ToastTypes.danger);
          }
        });
    } else {
      UserService.addUser(user, uData)
        .then((resp) => {
          setShowAddUser(false);
          setUserList([...userList, resp]);
          userListGlobal = [...userList];
          setEmail("");
          setName(userData.name ? userData.name : "");
          addToast("User added successfully", "", ToastTypes.success);
          // setUserListGlobal([...userList, resp]);
        })
        .catch((error) => {
          if (error && error.response && error.response.data.message) {
            addToast(error.response.data.message, "", ToastTypes.danger);
          }
        });
    }
  };

  const getOrganizationUsers = (orgId) => {
    setIsLoading(true);
    UserService.getOrganizationUsers(user, orgId)
      .then((resp) => {
        userListGlobal = resp;
        setIsLoading(false);
        setUserList(resp);
        let test = resp.map((usr) => (usr.isActive ? usr._id : null));
        test = test.filter((d) => d != null);
        setIsUserActive(test);
      })
      .catch((error) => {
        setIsLoading(false);
        if (error && error.response && error.response.data.message) {
          addToast(error.response.data.message, "", ToastTypes.danger);
        }
      });
  };

  const getOrganizations = (user) => {
    OrganizationService.getAllOrganizations(user)
      .then((resp) => {
        setOrgList(resp);
      })
      .catch((error) => {
        if (error && error.response && error.response.data.message) {
          addToast(error.response.data.message, "", ToastTypes.danger);
        }
      });
  };

  const clearUserData = () => {
    setEmail("");
    setName("");
  };

  return (
    <div className="px-12 py-4">
      <div className="flex items-center justify-between my-4">
        <p className="font-bold text-lg text-primary">User Management</p>
        <input
          type="file"
          className="hidden"
          id="bulk-file"
          ref={hiddenBulkFileInput}
          onChange={handleBulkChange}
          accept={".csv"}
        />
        {/* <Button
          label="Import Users"
          className="btn-primary px-8"
          onClick={handleBulkFileClick}
        /> */}
      </div>
      {/* <div className="flex items-center my-4 justify-end">
        <a href={BulkUserSample} download="bulk_users.csv" target="_blank">
          <p className="font-bold text-primary cursor-pointer">
            Download sample import file
          </p>
        </a>
      </div> */}
      {!showAddUser ? (
        <>
          <div className="flex items-center justify-between pt-11">
            <div className="table-actions-container">
              <div className="relative text-gray-600 focus-within:text-gray-400">
                <TextInput
                  type="text"
                  placeholder="Search Users"
                  containerClassName="flex-grow block"
                  className="py-2 rounded-lg"
                  value={searchValue}
                  onChange={(val) => filter(val)}
                />
                <span className="absolute flex inset-y-0 items-center pl-2 right-0">
                  <button
                    type="submit"
                    className="p-1 focus:outline-none focus:shadow-outline">
                    <svg
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      viewBox="0 0 24 24"
                      className="w-6 h-6">
                      <path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
                    </svg>
                  </button>
                </span>
              </div>
            </div>
            <div className="">
              <Button
                label="Add Users"
                className="btn-primary px-8"
                onClick={showAddUserContent}
              />
            </div>
          </div>
          <div className="">
            {!isLoading ? (
              <div className="mt-5">
                {userList && userList.length > 0 ? (
                  <>
                    <Table
                      columns={columns}
                      data={userList}
                      defaultPageSize={100}
                      pageSize={100}
                      showPagination={false}
                    />
                    <ActionModal
                      active={isDeleteModalVisible}
                      setActive={setIsDeleteModalVisible}
                      onSubmit={onSubmitDelete}
                      header="You are deleting user :"
                      userName={
                        userData && userData?.firstName && userData?.lastName
                          ? userData?.firstName + " " + userData?.lastName
                          : ""
                      }
                      title="Are you sure you want to delete the record?"
                      btnColor="red"
                    />
                  </>
                ) : (
                  <div>
                    <p className="text-primary">User data not found</p>
                  </div>
                )}
              </div>
            ) : (
              <Loader />
            )}
          </div>
        </>
      ) : (
        <>
          <div className="">
            <div className="">
              <p className="font-bold text-lg text-primary">
                {showUserEdit && userData ? "Edit Member" : "Add Member"}
              </p>
            </div>
            <div className="my-6">
              <div className="flex items-center w-full">
                <div className="w-36">
                  <p className="t-grey font-bold">Name</p>
                </div>
                <div className="flex">
                  <div className="">
                    {showUserEdit ? (
                      <TextInput
                        key="1"
                        type="text"
                        value={name}
                        defaultValue={name}
                        placeholder="First Name"
                        containerClassName="flex-grow block"
                        className="py-2 rounded-lg t-grey"
                        onChange={(value) => {
                          setName(value);
                        }}
                        validator={(value) => {
                          if (value.length <= 0) {
                            return "Enter valid first name";
                          }
                        }}
                        disabled={role === "user" ? true : false}
                      />
                    ) : (
                      <TextInput
                        key="2"
                        type="text"
                        value={name}
                        placeholder="First Name"
                        containerClassName="flex-grow block"
                        className="py-2 rounded-lg t-grey"
                        onChange={(value) => {
                          setName(value);
                        }}
                        validator={(value) => {
                          if (value.length <= 0) {
                            return "Enter valid name";
                          }
                        }}
                      />
                    )}
                  </div>
                </div>
              </div>
              <div className="flex items-center">
                <div className="w-36">
                  <p className="t-grey font-bold">Email</p>
                </div>
                <div className="flex">
                  {showUserEdit ? (
                    <TextInput
                      key="1"
                      type="text"
                      value={email}
                      defaultValue={email}
                      placeholder="Email"
                      containerClassName="flex-grow block"
                      className="py-2 rounded-lg t-grey"
                      onChange={(value) => {
                        setEmail(value);
                      }}
                      validator={(value) => {
                        if (
                          !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
                            value
                          )
                        ) {
                          return "Email is not valid!";
                        }
                      }}
                      disabled={role === "user" ? true : false}
                    />
                  ) : (
                    <TextInput
                      key="2"
                      type="text"
                      value={email}
                      placeholder="Email"
                      containerClassName="flex-grow block"
                      className="py-2 rounded-lg t-grey"
                      onChange={(value) => {
                        setEmail(value);
                      }}
                      validator={(value) => {
                        if (
                          !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
                            value
                          )
                        ) {
                          return "Email is not valid!";
                        }
                      }}
                    />
                  )}
                </div>
              </div>
              <div>
                {showUserEdit ? (
                  <div className="flex items-center py-4">
                    <div className="t-grey font-bold w-36">User Status</div>
                    {isUserActive ? (
                      <div className="text-green-500">Active</div>
                    ) : (
                      <div className="text-red-500">Inactive</div>
                    )}
                    <Switch
                      className="ml-2"
                      toggle={isUserActive}
                      setToggle={setIsUserActive}
                    />
                  </div>
                ) : null}
              </div>
              <div className="flex items-center pb-4">
                <div className="w-36">
                  <p className="t-grey font-bold">Role</p>
                </div>
                <div className="border flex p-2 rounded-lg">
                  <select
                    onChange={(e) => setRole(e.target.value)}
                    value={role}
                    disabled={true}
                    // defaultValue={roles[0].value}
                    className={`t-grey ${
                      user.role !== "superAdmin" ? "w-36" : ""
                    }`}>
                    {user.role === "superAdmin"
                      ? showUserEdit
                        ? roles.map((r) => {
                            return (
                              <option value={r.value} key={r.value}>
                                {r.label}
                              </option>
                            );
                          })
                        : addUserRoles.map((r) => {
                            return (
                              <option value={r.value} key={r.value}>
                                {r.label}
                              </option>
                            );
                          })
                      : hospitalRoles.map((r) => {
                          return (
                            <option value={r.value} key={r.value}>
                              {r.label}
                            </option>
                          );
                        })}
                  </select>
                </div>
              </div>
              <div>
                {showUserEdit ? (
                  <div className="flex items-center">
                    <div className="w-36">
                      <p className="t-grey font-bold">Organization</p>
                    </div>
                    <div className="border flex p-2 rounded-lg w-1/4">
                      <select
                        onChange={(e) => {
                          setUserOrgId(e.target.value);
                        }}
                        value={userOrgId}
                        className={`t-grey w-full`}>
                        {orgList.map((r) => {
                          return (
                            <option value={r._id} key={r._id}>
                              {r.name}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
            <div className="">
              <Button
                label={showUserEdit && userData ? "Save Changes" : "Add Users"}
                className="btn-primary px-8"
                onClick={addUser}
                disabled={!isUserFormSubmitable}
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default UserManagement;
